import { render, staticRenderFns } from "./xccCode.vue?vue&type=template&id=cab645dc&scoped=true"
import script from "./xccCode.vue?vue&type=script&lang=js"
export * from "./xccCode.vue?vue&type=script&lang=js"
import style0 from "./xccCode.vue?vue&type=style&index=0&id=cab645dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab645dc",
  null
  
)

export default component.exports